'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';
import React from 'react';

import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';

import { buildImageSizes } from '@eliadmin/core/src/components/image/image-helpers';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { getTextFromHTML } from '@eliadmin/core/src/utils/misc-utils';

import { MdOutlineKeyboardArrowRight } from 'react-icons/md';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

export type BlogCardProps = {
  className?: {
    main?: string;
    link?: string;
    image?: string;
    title?: string;
    date?: string;
    contentContainer?: string;
    content?: string;
  };
  blog: Blog;
};

export function BlogCard({ blog }: BlogCardProps) {
  const { t } = useTranslations();
  const textContent = getTextFromHTML(blog.content);
  const locale = useLocaleStore(state => state.currentLocale);
  const imageUrl = blog?.image?.url?.trim() || '/images/placeholder.png';

  return (
    <Link
      href={ROUTES.BLOG_DETAIL({ slug: blog.slug }) ?? '#'}
      prefetch={false}
      className="flex w-full flex-col items-start justify-start gap-4 sm:flex-row sm:gap-8 md:justify-between"
    >
      <div className="relative h-[210px] w-full overflow-hidden rounded-[6px] sm:h-[260px] sm:max-w-[290px] md:h-[191px]">
        <span className="absolute left-4 top-4 z-[10] overflow-hidden rounded-[6px] border border-[#D8D8DB] bg-white px-2 py-1 text-sm font-medium text-primary">
          {blog?.categories[0]?.name}
        </span>
        <Image
          src={imageUrl}
          alt={resolveImageAlt(blog?.image, blog?.name)}
          fill
          style={{ objectFit: 'cover', objectPosition: 'center' }}
          sizes={buildImageSizes([{ size: '100vw' }])}
        />
      </div>
      <div className="items-starts flex w-full flex-col justify-start gap-4 md:max-w-[520px]">
        {/* <span className="text-sm font-medium text-[#888888]">
          {new Date(blog?.created_at).toLocaleDateString(locale)}
        </span> */}
        <h2 data-ea-visual-tag="h3" className="line-clamp-2 h-[52px] text-lg font-bold text-foreground sm:line-clamp-1 sm:h-[23px]">
          {blog?.name}
        </h2>
        <HtmlRendererRaw
          as="p"
          className="line-clamp-4 h-[84px] w-full overflow-hidden text-sm text-[#888888] sm:line-clamp-2 sm:h-[52px] sm:text-base"
          html={textContent}
        />
        <Button className="w-full sm:w-fit" variant={'secondary'}>
          <p>{t('text1148')}</p> <MdOutlineKeyboardArrowRight size={20} />
        </Button>
      </div>
    </Link>
  );
}
